import { required, email } from 'vuelidate/lib/validators'
import { isValidPhoneNumber } from 'libphonenumber-js'
import countries from '@/data/miscData/countries'

const formData = {
  'user.name': {
    size: 6,
    type: 'text',
    name: 'user.name',
    label: 'Nome completo',
    placeholder: 'Digite seu nome completo',
    value: null
  },
  'displayName': {
    size: 6,
    type: 'text',
    name: 'displayName',
    label: 'Nome para exibição',
    placeholder: 'Nome a ser visualizado pelos pacientes',
    value: null
  },
  crm: {
    size: 3,
    type: 'text',
    mask: '################',
    name: 'crm',
    label: 'Número do CRM',
    disabled: true,
    placeholder: 'Digite o nº do seu CRM',
    value: null
  },
  'user.cpf': {
    size: 3,
    type: 'text',
    name: 'user.cpf',
    label: 'CPF',
    disabled: false,
    placeholder: 'Digite seu CPF',
    mask: '###.###.###-##',
    value: null
  },
  'user.rg': {
    size: 3,
    type: 'text',
    name: 'user.rg',
    label: 'RG',
    maxlength: 15,
    placeholder: 'Digite seu RG',
    value: null
  },
  'user.gender': {
    size: 3,
    type: 'radio',
    name: 'gender',
    label: 'Sexo',
    value: null,
    radios: [
      {
        name: 'M',
        label: 'M',
        value: 'M'
      },
      {
        name: 'F',
        label: 'F',
        value: 'F'
      }
    ]
  },
  'user.email': {
    size: 4,
    type: 'text',
    name: 'user.email',
    label: 'E-mail',
    placeholder: 'Digite seu e-mail',
    value: null
  },
  'user.ddiContactPhone': {
    size: 1,
    type: 'select',
    name: 'user.ddiContactPhone',
    label: 'DDI',
    value: null,
    options: countries
  },
  'user.contactPhone': {
    size: 2,
    type: 'text',
    name: 'user.contactPhone',
    label: 'Telefone',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'Digite seu telefone',
    value: null
  },
  university: {
    size: 3,
    type: 'text',
    name: 'university',
    label: 'Faculdade',
    placeholder: 'Onde se formou?',
    value: null
  },
  universityStartDate: {
    size: 1,
    type: 'text',
    name: 'universityStartDate',
    label: 'Início',
    placeholder: 'AAAA',
    value: null,
    mask: '####'
  },
  universityEndDate: {
    size: 1,
    type: 'text',
    name: 'universityEndDate',
    label: 'Conclusão',
    placeholder: 'AAAA',
    value: null,
    mask: '####'
  },
  isAmbEspecialization: {
    size: 4,
    type: 'radio',
    name: 'isAmbEspecialization',
    label: 'Possui título de especialização pela AMB?',
    value: null,
    radios: [
      {
        name: 'is_amb',
        label: 'Sim',
        value: 1
      },
      {
        name: 'not_amb',
        label: 'Não',
        value: 0
      }
    ]
  },
  isAttendHealthInsurance: {
    size: 3,
    type: 'radio',
    name: 'isAttendHealthInsurance',
    label: 'Atende plano de saúde?',
    value: null,
    radios: [
      {
        name: 'is_plan',
        label: 'Sim',
        value: 1
      },
      {
        name: 'not_plan',
        label: 'Não',
        value: 0
      }
    ]
  },
  'medicalSpecialty': {
    size: 6,
    type: 'list',
    name: 'medicalSpecialty',
    label: 'Título de especialista',
    disabled: true,
    placeholder: 'Selecione um título',
    value: null,
    options: [],
    tooltip: 'Caso precise alterar seu título\nde especialista, por favor, entre\nem contato conosco através\ndo chat ou através do e-mail\natendimento@drconecta.com.br.'
  },
  'specializationCourses': {
    size: 12,
    type: 'array',
    name: 'specializationCourses',
    label: 'Cursos de especialização',
    placeholder: 'Cursos de especialização',
    value: null,
    tooltip: 'Para adicionar seus cursos de \nespecialização, digite os nomes\nno campo abaixo e pressione\n<Enter> ou clique no botão +'
  }
}

const requiredFields = [
  'user.name',
  'user.cpf',
  'user.rg',
  'user.email',
  'user.contactPhone',
  'university',
  'universityStartDate',
  'universityEndDate',
  'isAmbEspecialization',
  'isAttendHealthInsurance'
]

const validations = {}

for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

validations['user.email'] = {
  value: {
    required,
    email
  }
}

validations['user.contactPhone'] = {
  value: {
    required,
    isValid (value) {
      if (value) {
        const iso = this.formData['user.ddiContactPhone'].value
        return isValidPhoneNumber(value, String(iso.toUpperCase()))
      }

      return true
    }
  }
}

validations['user.rg'] = {
  value: {
    required,
    isValid (value) {
      if (value) {
        const onlyDigits = value.replace(/\D/gi, '')
        return !/^[^1-9]+$/gi.test(onlyDigits)
      }

      return false
    }
  }
}

validations['user.cpf'] = {
  value: {
    required,
    isValid (value) {
      return this.fn_VALID_CPF(value)
    }
  }
}

export {formData, validations}
